const initialAnnexeCategoriesState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  deleting: false,
  deleted: false,
  items: [],
  modified: { enabled: [], disabled: [] },
  labelsForm: { fr: "", en: "", nl: "" },
  error: null
};
export const annexeCategoriesReducer = (
  state = initialAnnexeCategoriesState,
  action
) => {
  switch (action.type) {
    case "INIT_ANNEXE_CATEGORIES": {
      return initialAnnexeCategoriesState;
    }
    case "SET_ANNEXE_CATEGORIES": {
      return {
        ...state,
        items: action.items
      };
    }
    case "SET_MODIFIED_CATEGORIES": {
      return {
        ...state,
        modified: action.modified
      };
    }
    case "SET_STANDARD_CATEGORIES": {
      return {
        ...state,
        items: {
          ...state.items,
          standard: action.standard
        }
      };
    }
    case "SET_CREATED_CATEGORIES": {
      return {
        ...state,
        items: {
          ...state.items,
          created: action.created
        }
      };
    }
    case "SET_LABELS_FORM": {
      return {
        ...state,
        labelsForm: action.labelsForm
      };
    }
    case "FETCH_ANNEXE_CATEGORIES_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ANNEXE_CATEGORIES_FULFILLED": {
      const data = action.payload.data.data;
      let items = { standard: [], created: [] };
      // eslint-disable-next-line array-callback-return
      data.map(item => {
        if (item.organization === null) {
          items.standard.push(item);
        } else {
          items.created.push(item);
        }
      });

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: items
      };
    }
    case "FETCH_ANNEXE_CATEGORIES_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case `UPDATE_ANNEXE_CATEGORIES_STATE_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `UPDATE_ANNEXE_CATEGORIES_STATE_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `UPDATE_ANNEXE_CATEGORIES_STATE_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    case `SAVE_ANNEXE_CATEGORY_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_ANNEXE_CATEGORY_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_ANNEXE_CATEGORY_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    case `UPDATE_ANNEXE_CATEGORY_PENDING`: {
      return { ...state };
    }
    case `UPDATE_ANNEXE_CATEGORY_FULFILLED`: {
      return { ...state };
    }
    case `UPDATE_ANNEXE_CATEGORY_REJECTED`: {
      return { ...state };
    }

    case `DELETE_ANNEXE_CATEGORY_PENDING`: {
      return { ...state, deleted: false, deleting: true };
    }
    case `DELETE_ANNEXE_CATEGORY_FULFILLED`: {
      return {
        ...state,
        deleting: false,
        deleted: true
      };
    }
    case `DELETE_ANNEXE_CATEGORY_REJECTED`: {
      return {
        ...state,
        deleted: false,
        deleting: false
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/annexe-category.js